import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { useLang } from "../i18n/LanguageContext";

export default function FinalCTA() {
  const { t } = useLang();
  return (
    <section data-testid="final-cta" className="relative py-20 md:py-24 bg-[#6B1F2C] text-[#F4F1E8]">
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.08]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
      />
      <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14 grid grid-cols-12 gap-6 md:gap-8 items-center">
        <div className="col-span-12 md:col-span-8">
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#D4AF37] mb-4">
            {t("finalCta.overline")}
          </p>
          <h2 className="font-serif-display font-light text-2xl sm:text-3xl md:text-4xl lg:text-5xl tracking-tight leading-tight">
            {t("finalCta.title1")}{" "}
            <span className="italic text-[#D4AF37]">{t("finalCta.titleItalic")}</span>
          </h2>
        </div>
        <div className="col-span-12 md:col-span-4 md:text-right">
          <Link
            to="/quote"
            data-testid="final-cta-button"
            className="group inline-flex items-center gap-3 px-6 md:px-8 py-3.5 md:py-4 bg-[#D4AF37] text-[#0F1E33] font-medium tracking-wide hover:bg-[#C9D9EC] transition-colors"
          >
            {t("common.getQuote")}
            <ArrowRight size={18} weight="bold" className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
}
